import { Loader2Icon } from 'lucide-react'
import { cn } from '@/lib/utils'

/** `role="status"` is asserted on by RequireAuth.test — do not drop it. */
export function Spinner({ label, className }: { label?: string; className?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn('flex min-h-svh flex-col items-center justify-center gap-4 p-6 text-center', className)}
    >
      <Loader2Icon className="text-muted-foreground size-8 animate-spin motion-reduce:animate-[spin_2.4s_linear_infinite]" aria-hidden />
      {label && <p className="text-muted-foreground text-sm">{label}</p>}
    </div>
  )
}
